import React from 'react'
import { Component } from 'reflux'
import DynamicTable from 'Components/dynamicTable'
import CollapsibleCard from 'Components/collapsibleCard'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import { Button, ButtonGroup, UncontrolledTooltip as Tooltip } from 'reactstrap'
import { toast } from 'react-toastify'
import { ExpectedDeliveryStatusActions, ExpectedDeliveryStatusStore, STATUS } from 'Stores/expectedDeliveryStatusStore'

export default class ExpectedDeliveryStatusList extends Component {
  constructor(props) {
    super(props)
    this.stores = [ExpectedDeliveryStatusStore]
    this.storeKeys = ['expectedDeliveryStatuses', 'status']
  }

  componentDidMount() {
    ExpectedDeliveryStatusActions.getExpectedDeliveryStatuses()
  }

  componentDidUpdate() {
    if (this.state.status === STATUS.FETCHING_ERROR) {
      toast.error('Fetching ExpectedDeliveryStatuses Failed', {
        autoClose: 7500,
        onClose: () => {
          ExpectedDeliveryStatusActions.clearToast()
        }
      })
      ExpectedDeliveryStatusActions.clearToast()
    }
    if (this.state.status === STATUS.DELETE_ERROR) {
      toast.error('Delete ExpectedDeliveryStatus Failed', {
        autoClose: 7500,
        onClose: () => {
          ExpectedDeliveryStatusActions.clearToast()
        }
      })
      ExpectedDeliveryStatusActions.clearToast()
    }
    if (this.state.status === STATUS.DELETE_SUCCESS) {
      toast.success('ExpectedDeliveryStatus Deleted', {
        autoClose: 7500,
        onClose: () => {
          ExpectedDeliveryStatusActions.clearToast()
        }
      })
      ExpectedDeliveryStatusActions.clearToast()
    }
  }

  render() {
    if (this.state.status === STATUS.IS_FETCHING) {
      return <FontAwesomeIcon icon='spinner' spin />
    }
    return (
      <CollapsibleCard startOpen header={<strong>Expected Delivery Statuses</strong>}>
        <DynamicTable
          responsive
          size='sm'
          options={{
            startSort: {
              dir: 'DESC',
              column: 'ExpectedDeliveryStatusID'
            },
            addField: e => {
              return (
                <td>
                  <ButtonGroup>
                    <Tooltip target={'edit' + e.ExpectedDeliveryStatusID}>Rediger</Tooltip>
                    <Button tag={Link} to={'/expected-delivery-status/' + e.ExpectedDeliveryStatusID} id={'edit' + e.ExpectedDeliveryStatusID}>
                      <FontAwesomeIcon icon='edit' />
                    </Button>
                    <Tooltip target={'delete' + e.ExpectedDeliveryStatusID}>Slet</Tooltip>
                    <Button
                      id={'delete' + e.ExpectedDeliveryStatusID}
                      color='danger'
                      onClick={() => {
                        if (confirm('Vil du slette denne leveringsstatus?')) {
                          ExpectedDeliveryStatusActions.deleteExpectedDeliveryStatus(e.ExpectedDeliveryStatusID)
                        }
                      }}
                    >
                      <FontAwesomeIcon icon='trash' />
                    </Button>
                  </ButtonGroup>
                </td>
              )
            }
          }}
          headers={{
            ExpectedDeliveryStatusID: 'ID',
            statusType: 'Status Type',
            name: 'Name',
            description: 'Description'
          }}
          data={this.state.expectedDeliveryStatuses}
        />
      </CollapsibleCard>
    )
  }
}
